import { isUserAuthorized } from 'utils/helpers';
import aclMatrix from 'common/aclMatrix';
import { ACL_MATRIX } from 'common/permissions';
import { enableBusinessFlexShip } from 'services/business';

import BusinessSwitch from '../BusinessSwitch';

const BusinessAllowFlexShipSwitch = ({
  businessData = {},
  submitBusinessUpdate
}) => {
  const { isAllowedToSubscribe = false } = businessData?.flexShip || {};

  const disableSwitch = !isUserAuthorized(aclMatrix.BUSINESSES_DETAILS, [
    ACL_MATRIX.BUSINESS_UPDATE_FLEX_SHIP
  ]);

  const switchAllowBusinessFlexShip = ({ value, ...options }) => {
    const payload = {
      isAllowedToSubscribe: !isAllowedToSubscribe
    };
    submitBusinessUpdate(payload, {
      callback: enableBusinessFlexShip
    });
  };

  return (
    <BusinessSwitch
      disabled={disableSwitch}
      initialChecked={isAllowedToSubscribe}
      onChange={switchAllowBusinessFlexShip}
    />
  );
};

export default BusinessAllowFlexShipSwitch;
